import script from "./config-form-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./config-form-drawer.vue?vue&type=script&lang=ts&setup=true"

import "./config-form-drawer.vue?vue&type=style&index=0&id=6be6c192&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\yang'ya'fei\\Documents\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6be6c192"]])

export default __exports__